import React, { useState } from "react";
import { PiArrowCircleRightFill } from "react-icons/pi";
import { PiArrowCircleLeftFill } from "react-icons/pi";
import { FaCircle } from "react-icons/fa";
import CenterContainer from "./ContainersAndData/CenterContainer";
import LeftContainer from "./ContainersAndData/LeftContainer";
import RightContainer from "./ContainersAndData/RightContainer";
import headingEn from "../../../languages/en/offers/heading";
import headingTh from "../../../languages/th/offers/heading";
const SeventhSection = ({ language }) => {
  const heading = language === "en" ? headingEn : headingTh;

  const [currentScreen, setCurrentScreen] = useState(1);

  // Function to handle left arrow click
  const handleLeftArrowClick = () => {
    setCurrentScreen((prevScreen) => Math.max(prevScreen - 1, 0));
  };

  // Function to handle right arrow click
  const handleRightArrowClick = () => {
    setCurrentScreen((prevScreen) => Math.min(prevScreen + 1, 2)); // Assuming you have 3 containers (Left, Center, Right)
  };

  return (
    <div id="packages" className="h-900">
      <section
        className="h-full flex flex-col items-center  relative mb-52 
      md:mb-0
      "
      >
        {/* Big centered title */}
        <h2 className="text-4xl font-medium mb-8 text-center">
          {heading.heading1} <br />
          {heading.heading2}
        </h2>

        {/* Left and Right containers */}
        <div className="relative flex items-center justify-center  w-3/5">
          {currentScreen === 0 ? (
            <>
              <div
                className=" z-10 absolute w-72  text-xs bg-white border-4 top-20
        rounded-c1 p-3 shadow-xl shadow-slate-500 dis border-primary-300"
              >
                <RightContainer language={language} />
              </div>
              <div
                className="hidden md:block absolute left-0 w-96  bg-white border top-0
        border-gray-300 rounded-3xl p-4 text-xs opacity-60"
              >
                <CenterContainer language={language} />
              </div>
              <div
                className="hidden md:block absolute right-0 w-96  bg-white border top-20
        border-gray-300 rounded-3xl p-4 text-xs opacity-60"
              >
                {" "}
                <LeftContainer language={language} />
              </div>
            </>
          ) : currentScreen === 1 ? (
            <>
              <div
                className="z-10 absolute w-72  text-xs bg-white border-4 top-0
     rounded-c1 p-3 shadow-xl shadow-slate-500 dis border-primary-300"
              >
                <CenterContainer language={language} />
              </div>
              <div
                className="hidden md:block absolute left-0 w-96  bg-white border top-20
       border-gray-300 rounded-3xl p-4 text-xs opacity-60"
              >
                <LeftContainer language={language} />
              </div>

              <div
                className="hidden md:block
    absolute right-0 w-96  bg-white border top-20 
       border-gray-300 rounded-3xl p-4 text-xs opacity-60"
              >
                <RightContainer language={language} />
              </div>
            </>
          ) : (
            <>
              <div
                className="z-10 absolute w-72  text-xs bg-white border-4 top-20
        rounded-c1 p-3 shadow-xl shadow-slate-500 dis border-primary-300"
              >
                <LeftContainer language={language} />
              </div>
              <div
                className="hidden md:block md:absolute left-0 w-96  bg-white border top-20
        border-gray-300 rounded-3xl p-4 text-xs opacity-60"
              >
                <RightContainer language={language} />
              </div>
              <div
                className="hidden md:block md:absolute right-0 w-96  bg-white border top-0
        border-gray-300 rounded-3xl p-4 text-xs opacity-60"
              >
                <CenterContainer language={language} />
              </div>
            </>
          )}
        </div>

        {/* Navigation arrows */}
        <div className="hidden md:flex mt-4 space-x-4 absolute transform -translate-y-1/2 top-1/2 left-20">
          <button onClick={handleLeftArrowClick}>
            <PiArrowCircleLeftFill className="w-10 h-10 inline" />
          </button>
        </div>

        <div className="hidden md:flex mt-4 space-x-4 absolute transform -translate-y-1/2 top-1/2 right-20">
          <button onClick={handleRightArrowClick}>
            <PiArrowCircleRightFill className="w-10 h-10 inline" />
          </button>
        </div>

        {/* Circle Indicators */}
        <div
          className="absolute flex  justify-center space-x-4
      bottom-20
      "
        >
          <button
            onClick={() => setCurrentScreen(0)}
            className={
              currentScreen === 0 ? "text-primary-500" : "text-gray-400"
            } // Assuming you have defined the primary and gray colors
          >
            <FaCircle className="w-4 h-4" />
          </button>
          <button
            onClick={() => setCurrentScreen(1)}
            className={
              currentScreen === 1 ? "text-primary-500" : "text-gray-400"
            } // Assuming you have defined the primary and gray colors
          >
            <FaCircle className="w-4 h-4" />
          </button>
          <button
            onClick={() => setCurrentScreen(2)}
            className={
              currentScreen === 2 ? "text-primary-500" : "text-gray-400"
            } // Assuming you have defined the primary and gray colors
          >
            <FaCircle className="w-4 h-4" />
          </button>
        </div>
      </section>
    </div>
  );
};

export default SeventhSection;
